import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    userInfo: null, //用户信息
    userPower: null, //用户权限
    approvalLogsVisible: false, //审批记录显示

    approvalLogsTableData: [], //审批记录数据

    auditStatusDic: [],
    workFlowSteps: [],

    SPONSORList: [], //当地雇主

    projectList: [], //项目部
    companyList: [], //用工单位
    departmentList: [], //部门
    positionList: [], //岗位
    countries: [], //国籍
    employmentForm: [], //用工形式
    dialogName: "",
  },
  getters: {},
  mutations: {
    //用户信息
    changeUserInfo(state, value) {
      state.userInfo = value;
    },
    //用户权限
    changeUserPower(state, value) {
      state.userPower = value;
    },
    // 审批记录显示
    changeApprovalLogsVisible(state, value) {
      state.approvalLogsVisible = value;
    },
    // 审批记录数据
    changeApprovalLogsTableData(state, value) {
      state.approvalLogsTableData = value;
    },
    changeAuditStatusDic(state, value) {
      state.auditStatusDic = value;
    },
    changeWorkFlowSteps(state, value) {
      state.workFlowSteps = value;
    },
    changeSPONSORList(state, value) {
      state.SPONSORList = value;
    },

    changeProjectList(state, value) {
      //项目部
      state.projectList = value;
    },
    changeCompanyList(state, value) {
      //用工单位
      state.companyList = value;
    },
    changeDepartmentList(state, value) {
      //部门
      state.departmentList = value;
    },
    changePositionList(state, value) {
      //岗位
      state.positionList = value;
    },
    changeCountries(state, value) {
      //国籍
      state.countries = value;
    },
    changeEmploymentForm(state, value) {
      //用工形式
      state.employmentForm = value;
    },
    changeDialogName(state, value) {
      //用工形式
      state.dialogName = value;
    },
  },
  actions: {},
  modules: {},
});
